import { ComboField } from '@components/Fields/ComboField';
import { DocumentoField } from '@components/Fields/DocumentoField';
import { IntegerField } from '@components/Fields/IntegerField';
import { StringField } from '@components/Fields/StringField';
import { FixedFilterPanel } from '@components/FixedFilterPanel';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IFilter } from '@hooks/useFilter';
import { MenuItem } from '@material-ui/core';
import { EnumVendedorStatus, IComboVendedorStatus } from '@model/Vendedor';
import { IVendedorFilter } from '@services/VendedorService';
import React from 'react';

export type VendedorFilterProps = {
    filter: IFilter<IVendedorFilter>
    isLoading: boolean
    vendedorStatusCombo: IComboVendedorStatus
}

export function VendedorFilter ({ filter, isLoading, vendedorStatusCombo }: VendedorFilterProps) {
    const handleReset = React.useCallback(() => {
        filter.resetFilter();
    }, [filter]);

    return (
        <FixedFilterPanel
            onSearch={filter.handleFilterRequest}
            onClear={handleReset}
            disabled={isLoading}
        >
            <HorizontalGrid spacing={1}>
                <GridItem xs={1}>
                    <IntegerField
                        field={filter.fields.vendedorId}
                        label="ID"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={4}>
                    <StringField
                        field={filter.fields.nome}
                        label="Nome"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={3}>
                    <DocumentoField
                        maskType="cpf"
                        field={filter.fields.cpf}
                        label="CPF"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={3}>
                    <ComboField
                        field={filter.fields.status}
                        label="Status"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem value={EnumVendedorStatus.None}>Todos</MenuItem>
                        {
                            vendedorStatusCombo.createOptions()
                        }
                    </ComboField>
                </GridItem>
            </HorizontalGrid>
        </FixedFilterPanel>
    )
}